<template>
  <div class="layout">
    <headerCell></headerCell>
    <div class="wrap-content">
      <bannerCell></bannerCell>
      <content1Cell></content1Cell>
      <content2Cell></content2Cell>
      <yxCell></yxCell>
      <content3Cell></content3Cell>
    </div>
    <footerCell></footerCell>
  </div>
  </template>

  <script>
  import headerCell from '../../components/header/index';
  import footerCell from '../../components/footer/index';
  import bannerCell from './cell/banner.vue'
  import content1Cell from './cell/content1Cell.vue'
  import content2Cell from './cell/content2Cell.vue'
  import content3Cell from './cell/content3Cell.vue'
  import yxCell from './cell/yxCell.vue'
  export default {
    name:'index_page',
    data(){
      return {

      }
    },
    components:{
      headerCell,
      footerCell,
      bannerCell,
      content1Cell,
      content2Cell,
      yxCell,
      content3Cell
    },
    methods:{

    },
    mounted() {
      this.$nextTick(() => {
      });
    }
  }
  </script>
  <style lang="less" scoped>
  .layout{
    width:100%;
    min-height: 100vh;
    background: #f7f7f7;
    overflow: hidden;
  }
  </style>
